module.exports = __webpack_public_path__ + "static/assets/54ae4ff5cb9eee86b2544af94992b91e.svg";